import { FC } from "react";
import { Outlet } from "react-router-dom";

const CreateVideoDubbing: FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default CreateVideoDubbing;
